// import Select from './Select';
import Loadable from "../../react-loadable";
import Option from "./Option";
import { SelectPropTypes } from "./PropTypes";
import OptGroup from "./OptGroup";
const Select = Loadable({
  loader: () => import("./Select"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
Select.Option = Option;
Select.OptGroup = OptGroup;
export { Option, OptGroup, SelectPropTypes };
export default Select;



// WEBPACK FOOTER //
// ./_rc-select-7.5.0/src/index.js